import formatSize from './formatSize'
import getMaxWidth from './getMaxWidth'

export default function constructSizeForm(
  unit,
  ratio,
  target,
  oldWidthInPixels
) {
  if (!target || !ratio) {
    return null
  }
  if (ratio.width && target.width) {
    const maxWidth = getMaxWidth(target.dpi, ratio.width)

    const currentWidth = oldWidthInPixels || target.width

    const height = formatSize(unit, target.dpi, currentWidth * ratio.height)
    const width = formatSize(unit, target.dpi, currentWidth)
    const maxValueWidth = formatSize(unit, target.dpi, maxWidth)
    const maxValueHeight = formatSize(unit, target.dpi, maxWidth * ratio.height)

    return {
      width: {
        value: width,
        defaultValue: width,
        isRequired: true,
        maxValue: maxValueWidth,
        validationRules: ['numeric', `maxValue:${maxValueWidth}`]
      },
      height: {
        value: height,
        defaultValue: height,
        isRequired: true,
        maxValue: maxValueHeight,
        validationRules: ['numeric', `maxValue:${maxValueHeight}`]
      }
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/utils/constructSizeForm.js